import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { IWarehouse } from 'ketshopweb-services'

export namespace IProducts {
  export interface IModelSearchReserved {
    ordercode: string
    customer: string
    page: number
    page_size: number
  }

  export interface OrderDetail {
    id: number
    order_id: number
    product_id: number
    qty: number
    price: number
    jsondata?: any
    updated_at: string
    created_at: string
    prop_enable: number
    feature_img: string
    title_lang1: string
    title_lang2: string
    title_lang3: string
    title_lang4: string
    properties_desc?: any
    property_info?: any
    properties_desc2?: any
    property_info2?: any
    sku: string
    cate_id: number
    weight: number
    temp_price: number
    product_price: number
    transaction_ref: string
    size_width: number
    size_length: number
    size_height: number
  }

  export interface SearchReservedResponse {
    count: number
    data: ({ product_qty: number; product_price: number } & Order)[]
  }

  export interface Customer {
    id: number
    type: string
    socialname?: any
    fbid?: any
    fb_id_chat?: any
    name: string
    lastname: string
    username: string
    status: number
    tel: string
    address1: string
    address2?: any
    subdistrict: string
    district: string
    province: string
    zipcode: string
    lastbill: number
    created_at: string
    updated_at: string
    total_cost: number
  }

  export interface Delivery {
    id: number
    type: string
    logo: string
    name: string
    unit: string
    price: number
    status: boolean
    cod: boolean
    cod_rate: number
    cod_rate_type: string
    format_price: string
    is_auto: boolean
    is_top_price: boolean
    courier_code: string
    updated_at: string
    updated_by: string
    created_at: string
    created_by: string
    top_up_price: number
  }

  export interface Paymenttype {
    id: number
    name: string
    account: string
    status: number
    created_at?: any
    updated_at: string
    created_by?: any
    updated_by?: any
  }

  export interface ChangeStatus {
    status: number
    datetime: Date
    created_by: string
  }

  export interface Order {
    id: number
    ordercode: string
    channel: string
    channel_id?: any
    channel_name?: any
    channel_ordercode?: any
    channel_shipment?: any
    status: number
    user_id: number
    tax_no?: any
    shipping_group_id?: number
    cod: number
    cod_rate: number
    cod_rate_type?: any
    cod_value: number
    shippingorder?: any
    purchase_id?: any
    shipconfirm: string
    shipconfirm_date?: any
    delivery_transfer_received: number
    delivery_service_type?: any
    delivery_send_start_time?: any
    delivery_send_end_time?: any
    delivery_type: string
    delivery: Delivery
    delichargeaddon: number
    delicharge: number
    add_delicharge: number
    amount: number
    amount_receive?: any
    bankname?: any
    banknote?: any
    vat: number
    vattype: number
    vatrate: number
    discount: number
    discountaddon: number
    use_point: number
    discount_point: number
    totals: number
    order_date: string
    updated_at: string
    created_at: string
    trackcode?: any
    name: string
    address1: string
    address2?: any
    district: string
    subdistrict: string
    province: string
    paymenttype: Paymenttype
    payment?: any
    zipcode: string
    tel: string
    weight: number
    note: string
    bill_address1: string
    bill_address2?: any
    bill_district: string
    bill_subdistrict: string
    bill_province: string
    bill_zipcode: string
    bill_name: string
    bill_lastname: string
    bill_tel: string
    bill_country_name: string
    bill_country_alpha2_code: string
    box_name: string
    box_value: string
    shippopbfdata?: any
    shippopdata?: any
    shippop?: any
    freeshipping: number
    freeshipping_manual?: any
    qutation_id?: any
    coupon_code?: any
    promotion_id?: any
    promotion_type?: any
    promotion_data?: any
    created_by: string
    updated_by: string
    frm_table?: any
    frmtb_id?: any
    customer_note: string
    creditpaytype: string
    transaction_no?: any
    shippop_status: string
    order_complete: number
    delivery_print: number
    change_status: ChangeStatus[]
    prepared_by?: any
    prepared_at?: any
    delivered_by?: any
    delivered_at?: any
    card_info?: any
    country_name: string
    country_alpha2_code: string
    customer: Customer
  }

  export interface Channel {
    warehouse_id: number
    warehouse_name: string
    channel: string
    channel_id: number
    channel_name: string
    channel_logo: string
  }

  export interface SearchActivityData {
    page: number
    page_size: number
    product_id: number
    warehouse_id: number
    channel_id: number
    start_date?: string
    end_date?: string
  }

  export type Activity = {
    forward_count: number
    in_count: number
    out_count: number
    remaining_count: number
    activity_title: string
    uuid: string
    type: 'transfer' | 'receive' | 'withdraw' | 'adjust' | 'restock'
    note: string
    code: string
    code_type: null | 'order' | 'warehouse_transfer'
    activity_by: string
    withdraw_by: string
    withdraw_at: string
    created_at: string
    warehousetransfer: IWarehouse.WarehouseTransferDetail
  }

  export interface SearchActivityResponse {
    count: number
    data: Activity[]
  }

  export interface WithdrawByGroupResponse {
    status: number
    message: string
    data: {
      id: number
      updated_ref: string
      arranged_at: string
      arranged_by: string
      confirm_quantity_at: string
      confirm_quantity_by: string
      prepared_status: number
      prepared_at: string
      prepared_by: string
      updated_at: string
      updated_by: string
    }
  }
}

@Injectable({
  providedIn: 'root',
})
export class KetshopwebProductsService {
  constructor(private _http: HttpClient) {}

  searchReserved(product_id: number, model: IProducts.IModelSearchReserved): Promise<IProducts.SearchReservedResponse> {
    return this._http
      .post(`/services/ketshopweb-products/products/reserved/${product_id}`, model)
      .toPromise() as Promise<IProducts.SearchReservedResponse>
  }

  addProductToTag(tag_id: number, data: { products: { id: number }[] }) {
    return this._http.post(`/services/ketshopweb-products/tags/${tag_id}/products`, data).toPromise()
  }

  removeProductFromTag(tag_id: number, data: { products: { id: number }[] }) {
    return this._http.post(`/services/ketshopweb-products/tags/${tag_id}/products/remove`, data).toPromise()
  }

  searchBrand(data:any){
    return this._http.post(`/services/ketshopweb-products/brands/search`, data).toPromise()
  }
  getBrandByID(id:number){
    return this._http.get(`/services/ketshopweb-products/brands/${id}`).toPromise()
  }
  getProductInBrand(id:number){
    return this._http.get(`/services/ketshopweb-products/brands/products_in_brand/${id}`).toPromise()
  }
  updateBrand(id:number,data){
    return this._http.put(`/services/ketshopweb-products/brands/update/${id}`,data).toPromise()
  }
  deleteBrand(id:number){
    return this._http.delete(`/services/ketshopweb-products/brands/${id}`).toPromise()
  }

  updateBrandSort(data:any){
    return this._http.post(`/services/ketshopweb-products/brands/update_sort`, data).toPromise()
  }

  createBrand(data:any){
    return this._http.post(`/services/ketshopweb-products/brands/create`, data).toPromise()
  }
  
  updateCompanySort(data:any){
    return this._http.post(`/services/ketshopweb-products/company/update_sort`, data).toPromise()
  }
  searchCompany(data:any){
    return this._http.post(`/services/ketshopweb-products/company/search`, data).toPromise()
  }
  deleteCompany(id:number){
    return this._http.delete(`/services/ketshopweb-products/company/${id}`).toPromise()
  }
  createCompany(data:any){
    return this._http.post(`/services/ketshopweb-products/company/create`, data).toPromise()
  }
  getCompanyByID(id:number){
    return this._http.get(`/services/ketshopweb-products/company/${id}`).toPromise()
  }
  getProductInCompany(id:number){
    return this._http.get(`/services/ketshopweb-products/company/products_in_company/${id}`).toPromise()
  }
  updateCompany(id:number,data){
    return this._http.put(`/services/ketshopweb-products/company/update/${id}`,data).toPromise()
  }


  searchProductPoint(data: any) {
    return this._http.post(`/services/ketshopweb-products/points/search_products`, data)
  }

  updateProductPoints(data: any) {
    return this._http.put(`/services/ketshopweb-products/points/update_points`, data).toPromise()
  }

  getChannels(product_id: number) {
    return this._http.get(`/services/ketshopweb-products/products/${product_id}/channels`).toPromise() as Promise<
      IProducts.Channel[]
    >
  }

  searchActivity(data: IProducts.SearchActivityData) {
    return this._http
      .post(`/services/ketshopweb-products/activity/search`, data)
      .toPromise() as Promise<IProducts.SearchActivityResponse>
  }

  withdrawByGroup(_updatedRef: string, state: 'prepared' | 'arranged' = 'prepared') {
    return this._http
      .post(`/services/ketshopweb-products/inventory/withdrawByGroup`, { shipping_group_ref: _updatedRef, state })
      .toPromise() as Promise<IProducts.WithdrawByGroupResponse>
  }
}
